(function () {
  const wrap = document.querySelector('[data-pd-tooltips]')
  if (!wrap) return

  const items = wrap.querySelectorAll('[data-pd-tip]')
  const miniCart = document.querySelector('cart-drawer#mini-cart')

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches
  }

  function isMiniCartOpen() {
    if (!miniCart) return false
    return miniCart.hasAttribute('open')
  }

  function forceTooltipBehind(tooltip) {
    if (!tooltip) return

    if (!tooltip.dataset.prevZIndex) {
      tooltip.dataset.prevZIndex = tooltip.style.zIndex || ''
    }

    tooltip.style.zIndex = '1'
  }

  function restoreTooltipZIndex(tooltip) {
    if (!tooltip) return
    tooltip.style.zIndex = tooltip.dataset.prevZIndex || ''
    delete tooltip.dataset.prevZIndex
  }

  function closeAll() {
    items.forEach(item => {
      const tooltip = item.querySelector('[data-pd-tooltip]')
      if (!tooltip) return

      tooltip.classList.remove('is-open')
      tooltip.style.transform = 'translateX(-50%)'
      restoreTooltipZIndex(tooltip)
    })
  }

  function fixTooltipInMobile(tooltip) {
    if (!isMobile()) return

    tooltip.style.transform = 'translateX(-50%)'

    const rect = tooltip.getBoundingClientRect()
    const vw = window.innerWidth
    const padding = 10

    if (rect.left < padding) {
      const shift = padding - rect.left
      tooltip.style.transform = 'translateX(-50%) translateX(' + shift + 'px)'
    }

    if (rect.right > vw - padding) {
      const shift = rect.right - (vw - padding)
      tooltip.style.transform = 'translateX(-50%) translateX(-' + shift + 'px)'
    }
  }

  items.forEach(item => {
    const tooltip = item.querySelector('[data-pd-tooltip]')
    if (!tooltip) return

    item.addEventListener('click', function (e) {
      const isDesktopHover = window.matchMedia('(hover:hover) and (pointer:fine)').matches
      if (isDesktopHover) return

      if (isMobile() && isMiniCartOpen()) {
        closeAll()
        return
      }

      e.preventDefault()
      e.stopPropagation()

      const isOpen = tooltip.classList.contains('is-open')
      closeAll()

      if (!isOpen) {
        tooltip.classList.add('is-open')
        forceTooltipBehind(tooltip)
        requestAnimationFrame(() => fixTooltipInMobile(tooltip))
      }
    })
  })

  window.addEventListener('resize', function () {
    const openTip = wrap.querySelector('.pd-tooltip.is-open')
    if (openTip) fixTooltipInMobile(openTip)
  })

  window.addEventListener(
    'scroll',
    function () {
      const openTip = wrap.querySelector('.pd-tooltip.is-open')
      if (openTip) fixTooltipInMobile(openTip)
    },
    { passive: true }
  )

  document.addEventListener('click', function () {
    closeAll()
  })

  wrap.addEventListener('click', function (e) {
    e.stopPropagation()
  })

  if (miniCart) {
    new MutationObserver(function () {
      if (isMobile() && isMiniCartOpen()) {
        closeAll()
      }
    }).observe(miniCart, { attributes: true, attributeFilter: ['open'] })
  }
})()
